import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';

import configuratorSlice from './configurator-slice';
import cardPreviewSlice from './card-preview-slice';
import addressBookSlice from './address-book-slice';

const store = configureStore({
  reducer: { 
    configurator: configuratorSlice.reducer, 
    cardPreview: cardPreviewSlice.reducer,
    addressBook: addressBookSlice.reducer 
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  })
});

export default store;